"use strict";function pickConversation$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.pickConversation$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.chat.pickConversation";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.2"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.2"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"4.7.9"},_a)),exports.pickConversation$=pickConversation$,exports.default=pickConversation$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/chat/pickConversation.js
// module id = 920
// module chunks = 106